import { Link } from "react-router-dom";
import { Heart, X } from "lucide-react";
import { useStore, formatINR } from "@/context/StoreContext";

const Wishlist = () => {
  const { wishlist, toggleWishlist } = useStore();

  return (
    <div data-testid="wishlist-page" className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24 min-h-[60vh]">
      <p className="overline text-[color:var(--vw-ink-soft)]">Kept for later</p>
      <h1 className="font-serif-display text-5xl md:text-7xl italic mt-3">Wishlist</h1>

      {wishlist.length === 0 ? (
        <div data-testid="empty-wishlist" className="mt-16 text-center max-w-md mx-auto">
          <Heart size={40} strokeWidth={1} className="mx-auto text-[color:var(--vw-ink-soft)]" />
          <p className="font-serif-display text-2xl mt-6">Nothing saved yet.</p>
          <p className="mt-3 text-sm text-[color:var(--vw-ink-soft)]">Tap the heart on pieces you love, and they'll live here.</p>
          <Link to="/shop" className="inline-block mt-8 overline border-b border-[color:var(--vw-ink)] pb-1 hover:opacity-70">Explore The Edit</Link>
        </div>
      ) : (
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {wishlist.map(item => (
            <article key={item.handle} data-testid={`wish-${item.handle}`} className="group">
              <Link to={`/product/${item.handle}`} className="block">
                <div className="relative aspect-[4/5] overflow-hidden bg-[color:var(--vw-bg-alt)] hover-zoom">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" loading="lazy" />
                  <button
                    data-testid={`remove-wish-${item.handle}`}
                    aria-label="Remove"
                    onClick={(e) => { e.preventDefault(); toggleWishlist(item); }}
                    className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-[color:var(--vw-bg)]/90 hover:bg-[color:var(--vw-bg)]"
                  ><X size={14} /></button>
                </div>
              </Link>
              <div className="mt-4">
                <Link to={`/product/${item.handle}`} className="font-serif-display text-xl hover:opacity-70">{item.title}</Link>
                <p className="text-sm font-utility mt-1">{formatINR(item.price)}</p>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
